import * as Yup from "yup";

import { yupObjectValidation } from "../../validationServices";

export const useOrganizationModalValidationSchema = () => {
  const initialValues = {
    comp_name: "",
  };

  const validationSchema = {
    comp_name: yupObjectValidation.company_name2,
  };

  const organizationModalValidationSchema = Yup.object().shape(
    validationSchema,
  );

  return {
    initialValues,
    organizationModalValidationSchema,
  };
};
